import { Box } from '@material-ui/core';
import { Document, Page } from 'react-pdf';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { useEffect, useRef } from 'react';

const DocumentThumbnailsSidebar = ({
  pdfConfig,
  setPdfConfig,
}) => {
  const theme = useTheme();
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current && pdfConfig.pageNumber) {
      const selectedThumb = document.getElementById(`thumb_${pdfConfig.pageNumber}`);
      if (selectedThumb) {
        const sidebar = contentRef.current;
        const thumbRect = selectedThumb.getBoundingClientRect();
        const sidebarRect = sidebar.getBoundingClientRect();
        
        const scrollTo = thumbRect.top - sidebarRect.top + sidebar.scrollTop - (sidebarRect.height / 2) + (thumbRect.height / 2);
        
        sidebar.scrollTo({
          top: scrollTo,
          behavior: 'smooth',
        });
      }
    }
  }, [pdfConfig.pageNumber]);

  return (
    <Box 
      ref={contentRef}
      sx={{
        height: '100%',
        flexShrink: 0,
        overflowY: 'auto',
        borderRight: '1px solid #e0e0e0',
        backgroundColor: '#f5f5f5',
        paddingInline: '10px',
        scrollBehavior: 'smooth',
        display: { 
          xs: 'none', 
          sm: 'block',
        },
      }}
    >
      <Document file={pdfConfig.contentUrl}>
        {Array.from({ 
          length: pdfConfig.numPages,
        }, (_, index) => (
          <Box 
            key={`thumb_${index + 1}`}
            id={`thumb_${index + 1}`}
            onClick={() => setPdfConfig((prev) => ({
              ...prev,
              pageNumber: index + 1,
            }))}
            sx={{
              margin: '10px 5px',
              border: pdfConfig.pageNumber === index + 1 
                ? `3px solid ${theme.palette.primary.main}` 
                : '1px solid #e0e0e0',
              borderRadius: 1,
              cursor: 'pointer',
              overflow: 'hidden',
              transition: 'all 0.2s',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          >
            <Page
              pageNumber={index + 1}
              width={150}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Box>
        ))}
      </Document>
    </Box>
  );
};

DocumentThumbnailsSidebar.propTypes = {
  pdfConfig: PropTypes.object.isRequired,
  setPdfConfig: PropTypes.func.isRequired,
  containerRef: PropTypes.object,
};

export default DocumentThumbnailsSidebar;
